import { profile } from '../common/service';
import Talents from './components/Talents';
import styles from './index.module.less';

function ScienceMD() {
  const renderProfile = () => (
    <div className={styles.profile}>
      <img src={profile.bgMD} alt="" className={styles.profile__bg} />
      <div className={styles.profile__title}>
        <div className={styles.profile__title__text}>{profile.label}</div>
        <div>{profile.subLabel}</div>
      </div>
      <div className={styles.profile__text}>{profile.content}</div>
    </div>
  );

  return (
    <section className={styles.service}>
      {renderProfile()}
      <Talents />
    </section>
  );
}

export default ScienceMD;
